import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getFactureById } from '../services/facturesAPI';

function FactureDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [facture, setFacture] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await getFactureById(id);
        if (res && res.success) {
          setFacture(res.data);
        } else {
          setError('Facture introuvable');
        }
      } catch (e) {
        setError('Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  if (loading) {
    return (
      <div style={{ padding: 24 }}>
        <p>Chargement de la facture...</p>
      </div>
    );
  }

  if (error || !facture) {
    return (
      <div style={{ padding: 24 }}>
        <p style={{ color: '#dc2626' }}>{error || 'Facture introuvable'}</p>
        <button className="btn-secondary" onClick={() => navigate(-1)}>Retour</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Facture {facture.numero || facture.numero_facture || 'Brouillon sans num\u00e9ro'}</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn-secondary" onClick={() => navigate(-1)}>Retour</button>
          {facture.pdf_url && (
            <button className="btn-primary" onClick={() => window.open(facture.pdf_url, '_blank')}>Télécharger PDF</button>
          )}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <div>
          <div><strong>Client</strong></div>
          <div>{facture.client || facture.client_id}</div>
        </div>
        <div>
          <div><strong>Statut</strong></div>
          <div>{(facture.statut || '').toUpperCase()}</div>
        </div>
        <div>
          <div><strong>Date facture</strong></div>
          <div>{facture.dateEmission || '-'}</div>
        </div>
        <div>
          <div><strong>Échéance</strong></div>
          <div>{facture.dateEcheance || '-'}</div>
        </div>
        <div>
          <div><strong>Montant</strong></div>
          <div>{facture.montant} {facture.monnaie || ''}</div>
        </div>
        <div>
          <div><strong>Référence</strong></div>
          <div>{facture.reference || '-'}</div>
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <div><strong>Description</strong></div>
          <div>{facture.description || '-'}</div>
        </div>
      </div>
    </div>
  );
}

export default FactureDetail;


